module.exports = __webpack_public_path__ + "img/vinho.654110cc.jpg";